import { useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';
import { userService } from '../utils/user-service';
import { SIGNALR_URL } from 'common/constants/common';
export var useSignalRConnector = function (url, baseUrl) {
    if (baseUrl === void 0) { baseUrl = SIGNALR_URL; }
    var _a = useState(null), hubConnection = _a[0], setHubConnection = _a[1];
    var signalRBaseUrl = baseUrl;
    useEffect(function () {
        var protocol = new signalR.JsonHubProtocol();
        var signalRConnection = new signalR.HubConnectionBuilder()
            .withUrl("".concat(signalRBaseUrl, "/").concat(url), {
            logger: signalR.LogLevel.None,
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
            accessTokenFactory: userService.getToken,
        })
            .withHubProtocol(protocol)
            .withAutomaticReconnect()
            .build();
        signalRConnection.start();
        setHubConnection(signalRConnection);
        return function () {
            signalRConnection.stop();
        };
    }, [signalRBaseUrl, url]);
    return hubConnection;
};
